import styled, { css } from 'styled-components';

const headerHeight = '80px';
const bottomSpace = '24px';
export const Container = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    height: calc(100vh - ${headerHeight} - ${bottomSpace});
    justify-content: flex-start;
    margin: 0px 24px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 0;
    }
  `}
`;
